import PageDatesLayout from './PageDatesLayout';

export default PageDatesLayout;
